import React, { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { useNavigate } from "react-router-dom";
import { Button, Card } from "react-bootstrap";
import { Loading } from "../../Components/Loading";
import { VehicleStatusReportForm } from "../../Components/VehiclesStatusReport/VehicleStatusReportForm";

const CreateVehicleStatusReport = () => {
  const { get } = useAxios();
  const navigate = useNavigate();
  const [weeks, setWeeks] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [reportedBy, setReportedBy] = useState([]);
  const [officeLocations, setOfficeLocations] = useState([]);
  const [vehicleStatusParameters, setVehicleStatusParameters] = useState([]);

  useEffect(() => {
    setFetching(true);
    const getVehicleStatusReportCreateDetails = async () => {
      try {
        const response = await get(`vehicle_status/create`);
        setWeeks(response.data.weeks);
        setVehicles(response.data.vehicles);
        setReportedBy(response.data.report_by);
        setOfficeLocations(response.data.office_location);
        setVehicleStatusParameters(response.data.vehicle_status_parameters);
      } catch (error) {
        if (error.response.status === 500) {
        }
      } finally {
        setFetching(false);
      }
    };
    getVehicleStatusReportCreateDetails();
  }, []);

  return (
    <>
      <Card className="container">
        {!!fetching ? (
          <Loading />
        ) : (
          <>
            <Card.Header className="d-flex justify-content-between mt-0 mb-4">
              <Card.Title>
                <div className="row">
                  <div className="col-md-12">
                    <h1 className="page-title">Vehicles Status Report </h1>
                  </div>
                </div>
              </Card.Title>

              <div className="row">
                <div className="col-md-12">
                  <Button onClick={() => navigate(-1)}>Back</Button>
                </div>
              </div>
            </Card.Header>

            <Card.Body>
              <VehicleStatusReportForm
                weeks={weeks}
                vehicles={vehicles}
                reportedBy={reportedBy}
                officeLocations={officeLocations}
                vehicleStatusParameters={vehicleStatusParameters}
              />
            </Card.Body>
          </>
        )}
      </Card>
    </>
  );
};
export default CreateVehicleStatusReport;
